define("shared/utils/file", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.base64toBlob = base64toBlob;
  _exports.getImageFromFile = getImageFromFile;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /**
   * Take a base64 encoding and return a file blob
   */
  function base64toBlob(base64, type) {
    const array = new Uint8Array(base64.length);
    for (let i = 0; i < base64.length; i++) {
      array[i] = base64.charCodeAt(i);
    }
    return new Blob([array], {
      type
    });
  }

  /**
   * Return a HTMLImageElement from a File with image MimeType
   */
  function getImageFromFile(file) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = function () {
        resolve(img);
        URL.revokeObjectURL(img.src);
      };
      img.onerror = () => {
        reject(new Error('Image could not be loaded'));
      };
      const objectURL = window.URL.createObjectURL(file);
      img.src = objectURL;
    });
  }
});